import { API } from './interceptor'
import {
  OLLIE_FINDINGS_WRITE_EVENTS,
  ollieFindingsSaved,
} from 'src/utils/ollieFindingsRefresh'

async function discrepancyApi(invoiceId, action, body) {
  if (!invoiceId) throw new Error('Missing invoice id')
  try {
    const path = `invoices/${encodeURIComponent(invoiceId)}/${action}`
    const response =
      body === undefined
        ? await API.get('api2', path)
        : await API.post('api2', path, { body })
    if (response?.success === false || !response?.data)
      throw new Error(
        response?.message || 'Could not load the invoice discrepancy.',
      )
    return response.data
  } catch (error) {
    throw new Error(
      error?.response?.data?.message ||
        error?.data?.message ||
        error?.message ||
        'Could not update the invoice discrepancy.',
    )
  }
}

export const getInvoiceDiscrepancy = invoiceId =>
  discrepancyApi(invoiceId, 'discrepancy')
export const requestDiscrepancyCredit = async (invoiceId, body) => {
  const data = await discrepancyApi(invoiceId, 'request-credit', body)
  ollieFindingsSaved({ event: OLLIE_FINDINGS_WRITE_EVENTS.CREDIT_UPDATED })
  return data
}
